//@flow
import {makeStyles, MenuItem} from '@material-ui/core';
import React from 'react';
import {colors} from '../../../../assets/styles/colors';
import PillSelect from '../../../../elements/PillSelect';
import {TABLE_CELLS} from '../../constants';
import {useTableCells} from '../../context/CellContext';
import {useToggleActiveCell} from '../../utils';
import {useIsMinimalPlan} from '../../../store/utils';
import PremiumFeatureBadge from '../../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';

const useStyles = makeStyles(theme => ({
  filterItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: `1px solid ${colors.grey200}`,
    padding: '0.75rem 1.5rem',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  filterLabel: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: '.9rem',
    maxWidth: '18ch',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  customCheckbox: {
    borderRadius: '50%',
    width: '1.5rem',
    height: '1.5rem',
    border: `1.25px solid ${colors.grey400}`,
    background: 'white',

    '&[data-checked="true"]': {
      border: `6px solid ${colors.primary}`,
    },
  },
}));

export default function TableCellFilter() {
  const classes = useStyles();

  const isMinimalPlan = useIsMinimalPlan();
  const activeCells = useTableCells();
  const toggleCell = useToggleActiveCell();

  return (
    <PillSelect label="Filtros en tabla" variant="outlined">
      {TABLE_CELLS.map(cell => (
        <MenuItem
          className={classes.filterItem}
          onClick={() => toggleCell(cell.id)}
          key={cell.id}
          disabled={
            'name' === cell.id || (isMinimalPlan && cell.disabledMinimal)
          }
        >
          <div>
            <span className={classes.filterLabel}>{cell.headerLabel}</span>
            {cell.disabledMinimal && isMinimalPlan && <PremiumFeatureBadge />}
          </div>
          <span
            className={classes.customCheckbox}
            data-checked={activeCells.some(({id}) => id === cell.id)}
          />
        </MenuItem>
      ))}
    </PillSelect>
  );
}
